import Component from '../abstracts/Component';

export default class AnimatedComponent extends Component {
    constructor(compEl) {
        super(compEl);
    }

    observerCallback(entry) {
        if (entry.isIntersecting) {
            entry.target.classList.toggle('animated', true)
        }
    }

    init() {
        super.init();
    }
}
